/**
 * Analytics provider interface for supporting multiple analytics services
 */
export interface AnalyticsProvider {
  // Event tracking
  trackEvent(eventName: string, properties?: Record<string, unknown>): void;

  // Page tracking
  trackPageView(pageName: string, properties?: Record<string, unknown>): void;

  // User identification
  identifyUser(userId: string, properties?: Record<string, unknown>): void;
  updateUserProfile(properties: Record<string, unknown>): void;

  // Error tracking
  trackError(error: Error | unknown, context?: Record<string, unknown>): void;

  // Session management
  reset(): void;
}

/**
 * Configuration for analytics providers
 */
export interface AnalyticsConfig {
  enablePostHog: boolean;
  enableGoogleAnalytics: boolean;
  isDevelopment: boolean;
}

/**
 * Event categories for consistent tracking
 */
export const EventCategories = {
  ONBOARDING: 'onboarding',
  FORM: 'form_interaction',
  CTA: 'engagement',
  USER: 'user',
  CONVERSION: 'conversion',
  ERROR: 'error',
  NAVIGATION: 'navigation',
} as const;

/**
 * Standard event types
 */
export const EventTypes = {
  // Onboarding
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_STEP_VIEWED: 'onboarding_step_viewed',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ONBOARDING_ABANDONED: 'onboarding_abandoned',

  // Form interactions
  FORM_STARTED: 'form_started',
  FORM_SUBMITTED: 'form_submitted',
  FORM_ABANDONED: 'form_abandoned',
  FORM_ERROR: 'form_error',
  FIELD_INTERACTION: 'field_interaction',

  // CTA interactions
  CTA_CLICKED: 'cta_clicked',
  BUTTON_CLICKED: 'button_clicked',

  // User events
  USER_REGISTERED: 'user_registered',
  USER_LOGIN: 'user_login',
  USER_PROFILE_UPDATED: 'user_profile_updated',

  // Conversions
  CONVERSION: 'conversion',
  GOAL_COMPLETED: 'goal_completed',

  // Navigation
  PAGE_VIEWED: 'page_viewed',

  // Errors
  ERROR_OCCURRED: 'error_occurred',
  EXCEPTION: 'exception',
} as const;
